import { Link } from "react-router";

/** Page title (optionally with a parent crumb) and right-aligned actions. */
export function PageHeader({ title, parent, actions }: { title: string; parent?: { to: string; label: string }; actions?: React.ReactNode }) {
  return (
    <div className="flex min-h-9 flex-wrap items-center gap-x-4 gap-y-2">
      <h1 className="flex items-center gap-2 text-lg font-semibold text-balance">
        {parent && (
          <>
            <Link to={parent.to} className="font-normal text-muted-foreground hover:text-foreground">{parent.label}</Link>
            <span aria-hidden className="font-normal text-muted-foreground">/</span>
          </>
        )}
        {title}
      </h1>
      {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
    </div>
  );
}
